export function generatePassword() {
  const buf = new Uint8Array(10);
  window.crypto.getRandomValues(buf);
  return btoa(String.fromCharCode.apply(null, buf));
}



// WEBPACK FOOTER //
// ./src/app/utils/generate-password.ts